import moment from "moment";

export default function (date1, date2 = {}) {
  let moment1 = moment(date1).startOf("day");
  let moment2 = moment(date2).startOf("day");

  if (moment1.diff(moment2, "days") == 0) {
    return "Hoje";
  } else if (moment1.diff(moment2, "days") == -1) {
    return "Ontem";
  } else if (moment1.diff(moment2, "days") == 1) {
    return "Amanhã";
  }
  return moment1.from(moment2);
}
